import { Component, OnInit, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { AppDataService, MerchantUserService, ConfigService, MerchantService, NationalityService } from 'app/services';
import { MessageService } from 'primeng/api';
import {
    Salutation, Suffix, CompanyPosition, MerchantStatusEnum, OnboardingSliderMenu,
    PersonalIdType, RejectReasonEnum, ChatMessageTypeEnum, DocumentStatusEnum
} from 'app/models';
import { MerchantUploadDocumentTypeEnum } from 'app/components/merchant';
import { Utils } from 'app/utils';
import { AppComponent } from 'app/app.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MerchantDocument, MerchantUserDocument } from '../../../models/merchant/merchant-document-upload';

enum DocumentsMenuEnum {
    CompanyDocuments = 0,
    AuthorizedRepresentativeDocuments = 1
}

@Component({
    selector: 'merchant-confirm-onboarding',
    templateUrl: './merchant-confirm-onboarding.component.html',
    styleUrls: ['./merchant-confirm-onboarding.component.scss',
        '../../../../styles/onboardingslidermenu.scss',
    ],
    providers: [MessageService]
})
export class MerchantConfirmOnboardingComponent implements OnInit, AfterViewInit {

    constructor(private messageService: MessageService, public appData: AppDataService, public app: AppComponent,
        public merchantUserService: MerchantUserService, public configService: ConfigService,
        public merchantService: MerchantService, private nationalityService: NationalityService,
        private formBuilder: FormBuilder) { }

    public personalIdTypes = PersonalIdType.PersonalIdTypeList;

    public merchanUser!: any;

    public loading: boolean = true;

    public merchantStatusEnum = MerchantStatusEnum;
    public activeMerchantStatus: MerchantStatusEnum = MerchantStatusEnum.Sent;
    public rejectReasonEnum = RejectReasonEnum;
    public documentStatusEnum = DocumentStatusEnum;
    public isRejectedDocument: boolean = false;

    public companyPositions = CompanyPosition.CompanyPositionList;
    public salutations = Salutation.SalutationList;
    public suffixes = Suffix.SuffixList;

    public nationalities: any = {};


    public onboardingSliderMenu!: OnboardingSliderMenu;

    //------------------MerchantCompanyConfirm---------------------
    public showMerchantCompanyConfirmSideBar: boolean = false;
    //-------------------------------------------------------------

    //------------------MerchantCompanyConfirm---------------------
    public showMerchantInformationConfirmSideBar: boolean = false;
    //-------------------------------------------------------------

    //------------------MerchantUploadDocument---------------------
    public documentsMenuEnum = DocumentsMenuEnum;
    public activeDocumentsMenuEnum: DocumentsMenuEnum = DocumentsMenuEnum.CompanyDocuments;

    public showMerchantUploadDocumentSideBar: boolean = false;
    public headerUploadDocumentTitleText: string = '';
    public merchantUploadDocumentTypeEnum = MerchantUploadDocumentTypeEnum;
    public activeMerchantUploadDocumentType!: MerchantUploadDocumentTypeEnum;
    //-------------------------------------------------------------

    //------------Chat sidebar---------------------
    public chatId: number = 0;
    public showChatSideBar: boolean = false;
    public chatMessageTypeEnum = ChatMessageTypeEnum;
    //------------End---------------------------------------------

    public reviewProposalCheckBox: boolean = false;

    ngOnInit(): void {

    }

    ngAfterViewInit() {
        this.getMerchantUserAndMerchantForConfirmed();
        this.onboardingSliderMenu = new OnboardingSliderMenu('#onboarding-slider-menu', 'item-' + this.activeMerchantStatus);
    }

    public setOnboardingSliderMenu(activeMerchantStatus: MerchantStatusEnum) {
        this.onboardingSliderMenu.setCurrent('item-' + activeMerchantStatus);
    }

    public getMerchantUserAndMerchantForConfirmed(): Promise<any> {
        return new Promise((resolve, reject) => {
            const dto = {
                MerchantUserId: this.appData.authData.MerchantUserId
            };

            this.loading = true;

            this.merchantUserService.getMerchantUserAndMerchantForConfirmed(dto, this.messageService)
                .then(data => {
                    if (!data.Success) {
                    this.loading = false;
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        reject('Error. Data is empty');
                        return;
                    }
                    if (data.MerchantStatus === MerchantStatusEnum.RejectedInitialOnboarding && data.RejectReasonId === RejectReasonEnum.RejectDocument) {
                        this.activeMerchantStatus = MerchantStatusEnum.ForApproval;
                        if (data.SECDocumentStatusId === DocumentStatusEnum.Rejected || data.BIR2303DocumentStatusId === DocumentStatusEnum.Rejected ||
                            data.PersonalIdentificationStatusId === DocumentStatusEnum.Rejected ||
                            data.CompanyAuthorizationLetterStatusId === DocumentStatusEnum.Rejected) {
                            this.isRejectedDocument = true;
                        }
                    } else {
                        this.activeMerchantStatus = data.MerchantStatus;
                    }
                    this.merchanUser = data;
                    this.merchanUser.Birthday = Utils.utcToLocalDate(this.merchanUser.Birthday);
                    if (this.merchanUser.PersonalIdType !== null) {
                        const pat = this.personalIdTypes.find(item => item.value === this.merchanUser.PersonalIdType);
                        this.merchanUser.PersonalIdTypeText = pat.name;
                    }
                    this.merchanUser.SECDocumentIssueDate = new Date(this.merchanUser.SECDocumentIssueDate).toLocaleDateString();
                    this.merchanUser.SECDocumentExpirationDate = new Date(this.merchanUser.SECDocumentExpirationDate).toLocaleDateString();
                    this.merchanUser.BirDateIssue = new Date(this.merchanUser.BirDateIssue).toLocaleDateString();
                    this.merchanUser.BIR2303DocumentExpirationDate = new Date(this.merchanUser.BIR2303DocumentExpirationDate).toLocaleDateString();
                    if (this.merchanUser.CompanyAuthorizationLetterExpirationDate !== null) {
                        this.merchanUser.CompanyAuthorizationLetterExpirationDate = new Date(this.merchanUser.CompanyAuthorizationLetterExpirationDate)
                            .toLocaleDateString();
                    }
                    this.merchanUser.CompanyAuthorizationLetterIssueDate = new Date(this.merchanUser.CompanyAuthorizationLetterIssueDate).toLocaleDateString();
                    this.merchanUser.PersonalIdentificationIssueDate = new Date(this.merchanUser.PersonalIdentificationIssueDate).toLocaleDateString();
                    this.merchanUser.PersonalIdentificationExpirationDate = new Date(this.merchanUser.PersonalIdentificationExpirationDate).toLocaleDateString();
                    this.setOnboardingSliderMenu(this.activeMerchantStatus);
                    this.loading = false;
                    resolve('Success');
                })
                .catch(err => {
                    this.loading = false;
                    throw err;
                });
        });
    }

    public confirmMerchant(statusId: MerchantStatusEnum) {

        if (this.merchanUser.MerchantStatus === this.merchantStatusEnum.DocumentUploaded
            && !this.reviewProposalCheckBox) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'You need to confirm that the data is correct.' });
            return;
        }

        const dto = {
            MerchantId: this.merchanUser.MerchantId,
            StatusId: (this.merchanUser.MerchantStatus === MerchantStatusEnum.RejectedInitialOnboarding) ? MerchantStatusEnum.ForApproval : statusId
        };

        this.loading = true;

        this.merchantService.merchantStatusChange(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                }
                else {
                    this.getMerchantUserAndMerchantForConfirmed();
                }
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public changeActiveDocumentsMenuEnum(active: DocumentsMenuEnum) {
        this.activeDocumentsMenuEnum = active;
    }

    public openMerchantCompanyConfirmSideBar({}) {
        this.showMerchantCompanyConfirmSideBar = !this.showMerchantCompanyConfirmSideBar;
    }

    changedShowMerchantCompanyConfirmSideBarEmit(value: any) {
        this.showMerchantCompanyConfirmSideBar = value;
    }

    changedShowMerchantInformationConfirmSideBarEmit(value: any) {
        this.showMerchantInformationConfirmSideBar = value;
    }

    public openMerchantUploadDocumentSideBar(titleText: string, documentType: MerchantUploadDocumentTypeEnum, documentStatus: DocumentStatusEnum) {
        if (this.activeMerchantStatus === MerchantStatusEnum.ApprovedAuthorizedRepresentative ||
            documentStatus === DocumentStatusEnum.Rejected && this.isRejectedDocument) {
            this.headerUploadDocumentTitleText = titleText;
            this.activeMerchantUploadDocumentType = documentType;
            this.showMerchantUploadDocumentSideBar = !this.showMerchantUploadDocumentSideBar;
        }
    }

    changedShowMerchantUploadDocumentSideBarEmit(object: any) {
        this.isRejectedDocument = object.isRejectedDocument;
        this.showMerchantUploadDocumentSideBar = object.showSideBar;
    }

    public clickMenuLink(activeMerchantStatus: MerchantStatusEnum) {
        const allowedMerchantStatuses: Record<number, MerchantStatusEnum[]> = {
            [MerchantStatusEnum.Sent]: [
                MerchantStatusEnum.Sent
            ],
            [MerchantStatusEnum.ApprovedCompanyDetail]: [
                MerchantStatusEnum.ApprovedCompanyDetail,
                MerchantStatusEnum.Sent
            ],
            [MerchantStatusEnum.ApprovedAuthorizedRepresentative]: [
                MerchantStatusEnum.ApprovedAuthorizedRepresentative,
                MerchantStatusEnum.Sent,
                MerchantStatusEnum.ApprovedCompanyDetail
            ],
            [MerchantStatusEnum.DocumentUploaded]: [
                MerchantStatusEnum.DocumentUploaded,
                MerchantStatusEnum.ApprovedAuthorizedRepresentative,
                MerchantStatusEnum.ApprovedCompanyDetail,
                MerchantStatusEnum.Sent
            ],
            [MerchantStatusEnum.ForApproval]: [
                MerchantStatusEnum.ForApproval,
                MerchantStatusEnum.DocumentUploaded,
                MerchantStatusEnum.ApprovedAuthorizedRepresentative,
                MerchantStatusEnum.ApprovedCompanyDetail,
                MerchantStatusEnum.Sent
            ],
            [MerchantStatusEnum.ForPartnerSignature]: [
                MerchantStatusEnum.ForPartnerSignature,
                MerchantStatusEnum.ForApproval,
                MerchantStatusEnum.DocumentUploaded,
                MerchantStatusEnum.ApprovedAuthorizedRepresentative,
                MerchantStatusEnum.ApprovedCompanyDetail,
                MerchantStatusEnum.Sent
            ],
        };

        if (allowedMerchantStatuses.hasOwnProperty(this.merchanUser.MerchantStatus) &&
            allowedMerchantStatuses[this.merchanUser.MerchantStatus]?.includes(activeMerchantStatus)) {
            this.setOnboardingSliderMenu(activeMerchantStatus);
            this.activeMerchantStatus = activeMerchantStatus;
        } else {
            this.messageService.add({
                severity: 'error', summary: 'Error',
                detail: 'You cannot advance to another step because you did not pass the previous one.'
            });
        }
    }

    public openChatSideBar() {
        this.showChatSideBar = !this.showChatSideBar;
    }
    changedShowChatSideBarEmit(value: any) {
        this.showChatSideBar = value;
    }

    changedMerchantSignContractEmit(value: any) {
        if (value) {
            this.openChatSideBar();
        }
    }

    deleteDocument(documentType: any) {
        switch(documentType){
            case MerchantUploadDocumentTypeEnum.SECDocuments:
                this.uploadDocumentToMerchant({
                    MerchantId: this.merchanUser.MerchantId,
                    SECDocumentIssueDate: null,
                    SECDocumentNumber: '',
                    SECDocumentImageUrl: ''
                });
                break;
            case MerchantUploadDocumentTypeEnum.BIR2303Document:
                this.uploadDocumentToMerchant({
                    MerchantId: this.merchanUser.MerchantId,
                    BirDateIssue: null,
                    BIR2303DocumentNumber: '',
                    BIR2303DocumentImageUrl: ''
                });
                break;
            case MerchantUploadDocumentTypeEnum.PersonalIdentification:
                this.uploadDocumentToMerchantUser({
                    MerchantUserId: this.merchanUser.MerchantUserId,
                    PersonalIdType: null,
                    PersonalIdentificationIssueDate: null,
                    PersonalIdentificationExpirationDate: null,
                    PersonalIdentificationNumber: '',
                    PersonalIdentificationImageUrl: ''
                });
                break;
            case MerchantUploadDocumentTypeEnum.CompanyAuthorizationLetter:
                this.uploadDocumentToMerchantUser({
                    MerchantUserId: this.merchanUser.MerchantUserId,
                    CompanyAuthorizationLetterIssueDate: null,
                    CompanyAuthorizationLetterExpirationDate: null,
                    CompanyAuthorizationLetterNumber: '',
                    CompanyAuthorizationLetterImageUrl: ''
                });
                break;
            default:
                break;
        }
    }

    public uploadDocumentToMerchant(dto: MerchantDocument) {
        this.loading = true;
        this.merchantService.merchantDocumentUpload(dto, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            }).catch((error: any) => {
                throw error;
            }).finally(() =>{
                this.getMerchantUserAndMerchantForConfirmed();
            });;
            this.loading = false;
    }

    public uploadDocumentToMerchantUser(dto: MerchantUserDocument) {
        this.loading = true;
            this.merchantUserService.merchantUserDocumentUpload(dto, this.messageService).then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                }).catch((error: any) => {
                    throw error;
                }).finally(() =>{
                    this.getMerchantUserAndMerchantForConfirmed();
                });
                this.loading = false;
            }
}
